import {createGate} from 'effector-react';

export function InitGate() {
    const gate = createGate();
    return gate;
}

export default InitGate;
